import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

//foundation used:
// xy Grid
// sticky
// Accordion

// Swiper
import { Swiper, Navigation, Autoplay, EffectFade } from 'swiper';
Swiper.use([Navigation, Autoplay, EffectFade]);

$.date = function(dateObject) {
  var d = new Date(dateObject);
  var day = d.getDate();
  var month = d.getMonth() + 1;
  var year = d.getFullYear();
  if (day < 10) {
      day = "0" + day;
  }
  if (month < 10) {
      month = "0" + month;
  }
  var date = day + "." + month + "." + year;

  return date;
};

$(document).foundation();

$('#mapsticky .sticky').on('sticky.zf.stuckto:top',function(){
  $(this).css({
    marginTop: $('#navsticky .sticky .title-bar-right').outerHeight()
  })
});

$(document).ready(function() {

  // MULTIPLE ????
  const swiper = new Swiper('.swiper-container', {
    speed: 1200,
    slidesPerView: 'auto',
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    freeMode: true,
    breakpoints: {
      910: {
        slidesPerView: 'auto',
        spaceBetween: 30,
      }
    }
  });

  var nextint, prevint;
  $('.swiper-button-next').on('mouseenter',function() {
    //swiper.translateTo( (swiper.translate - 200), 600, false, true);
    nextint =  setInterval(function(){
      swiper.translateTo( (swiper.translate - 10), 0, false, true);
    },40);
  }).on('mouseleave click',function() {
    clearInterval(nextint);
  });
  $('.swiper-button-prev').on('mouseenter',function() {
    // swiper.translateTo( (swiper.translate + 200), 600, false, true);
    prevint =  setInterval(function(){
      swiper.translateTo( (swiper.translate + 10), 0, false, true);
    },40);
  }).on('mouseleave click',function() {
    clearInterval(prevint);
  });



  var $calcontainer = $('#calendarResponse');
  var baseUrl = $('link[rel="canonical"]').attr('href');

      $calcontainer.append('<ul class="accordion" data-accordion data-multi-expand="true" data-allow-all-closed="true"></ul>');
  var $accUl = $calcontainer.find('ul.accordion');

  $.ajax({
    type: 'GET' ,
    url: baseUrl + '/wp-content/themes/hgw-theme/export.xml',
    dataType: 'xml' ,
    success: function(xml) {
      console.log('success');
          var $xml   = $( xml ).find('data');
          //console.log($xml.find('data'));

          $xml.find('Event').slice( 0, 10 ).each(function(i){
            //if ( i < 10) {
              var $starttime  = $.date( $(this).find('eventDates EventDate:first date').text() );
              var $endtime    = $.date( $(this).find('eventDates EventDate:last date').text() );
              var $title = $(this).find('title de').text();
              var $desc  = $(this).find('shortDescription de').text();
              if ( $starttime === $endtime )
                $endtime = '';
              else
                $endtime = ' — ' + $endtime;
                  //$desc = $($desc).text();
              $accUl.append('<li class="accordion-item" data-accordion-item><a href="#" class="accordion-title"><span class="grid-x"><span class="cell small-12 medium-6 large-5">' + $starttime + $endtime + '</span><span class="cell small-12 medium-auto">' + $title + '</span></span></a><div class="accordion-content" data-tab-content>' + $desc + '</div></li>');
            //}
          });


    }
  }).done(function() {
    $calcontainer.foundation();
  });


  // IE polyfill for image object fit
  //objectFitImages();

  // MAILS
  // $('.liambtn').each(function() {
  //   $(this).buildMailTo();
  // });
  //
  // $('.toliam').each(function() {
  //   $(this).buildMailLink();
  // });

  //$("#element").overflown()):

  // $.fn.overflown=function(){
  //   var e = this;
  //
  //   var width = 0;
  //   e.children().each(function() {
  //     width += $(this).width();
  //   });
  //   return width > e.width();
  // }

  $('.check-overflow .swiper-wrapper').each(function(){
    var $this = $(this);
    if ( $this.parent().find('.swiper-button-next').is('.swiper-button-disabled') && $this.parent().find('.swiper-button-prev').is('.swiper-button-disabled') )
      $this.parent().removeClass('has-controls');
    else
      $this.parent().addClass('has-controls');

    // if ( $this.overflown() ) {
    //   console.log('yay this'); // SLY // APPLY CLASSES
    //   $this.addClass('.has-controls').find('.swiper-controls').addClass('off');
    // } else {
    //   console.log('nay');
    //   $this.removeClass('.has-controls').find('.swiper-controls').removeClass('off');
    // }
  });

  var logoHeight = $('.title-bar-right').outerHeight()+10;
  $('#navsticky .sticky').css({'top': 0});
  console.log(logoHeight);

  $(window).on('resize',function(){
    logoHeight = $('.title-bar-right').outerHeight()+10;
    $('#navsticky .sticky.is-stuck').css({'transform': 'translateY(-' + logoHeight + 'px)' });
  });

  $(window).on('scroll', function(){
    var s = $(window).scrollTop();

    if ( Foundation.MediaQuery.is('small only') ) {
      if ( s >= logoHeight )
        $('#navsticky .sticky').addClass('is-stuck').removeClass('is-anchored').css({'transform': 'translateY(-' + logoHeight + 'px)' });
      else
        $('#navsticky .sticky').removeClass('is-stuck').addClass('is-anchored').css({'transform': 'translateY(0)' });
    }

    if ( s > 0 ) {
      $('body').addClass('scrolled');
      // $('#mapsticky .sticky').attr('data-margin-top',logoHeight/16);
      // $('#mapsticky .sticky').foundation('_calc',true);
    } else {
      $('body').removeClass('scrolled');
    }
  });


});
